/* eslint-disable */
import React, { useState, forwardRef } from 'react';
import peerviewLogo from '../../../assets/images/favicon.png';
import Modal from 'react-modal';

const ReportTabsPopover = forwardRef((props, ref) => {
    const [modalOpen, setModalOpen] = useState(false);
    const findReport = (reportTabKey) => props.allReportTabs.find((t) => t.key === reportTabKey);
    const naicsFocusedReport = props.naicsCode.startsWith('621') || props.naicsCode.startsWith('813') || props.entityType === "nonprofit";
    const naicsReportName = props.naicsCode.startsWith('621') ? "Doctor's P&L" : (props.naicsCode.startsWith('813') || props.entityType === "nonprofit") ? 'Functional Expenses' : null;
    const tyVSly = props.subdomain.includes('mauldinjenkins');
    const actVSfor = props.subdomain.includes('mauldinjenkins');

    const hrefBuilder = (subdomain, path) => {
        const domainSplit = document.location.host.split('.');
        domainSplit[0] = subdomain;
        return `${location.protocol}//${domainSplit.join('.')}${path}`;
    };

    const handleNewStandardTab = (tabInfo) => {
        if (props.navbar.user_type === 'Admin' || props.navbar.reports_unlocked) {
            props.handleNewTabFormModal(tabInfo)
        } else if (!props.navbar.reports_unlocked && props.navbar.user_type !== 'Admin') {
            setModalOpen(true)
        }
    }

    const activeTabAccess = (reportType) => {
        if (props.navbar.user_type === 'Admin' || props.navbar.reports_unlocked) {
            props.handleActiveTab(reportType, true)
        } else if (!props.navbar.reports_unlocked && props.navbar.user_type !== 'Admin') {
            setModalOpen(true)
        }   
    }

    const renderCustomReportSection = (adminOrNormal, type, sectionName) => {
        const reports = adminOrNormal === 'admin' ? props.defaultDashboardViews : props.customDashboardViews;

        if (reports[type].length > 0 || type === 'by_user') {
            return (
                <>
                    {reports[type].map((r) => (
                        <div
                            key={r.key}
                            className="report-option"
                            onClick={() => activeTabAccess(r, true)}
                        >
                            {r.name}
                        </div>
                    ))}
                </>
            );
        }
    };

    const ReportCreditPlanModal = () => {
        let modalPic = '';
        let modalTitle = '';
        let videoLink = null;
        const manageSubscriptionsURL = hrefBuilder(props.navbar.subdomain, '/subscriptions');
        const unlockReportsURL = hrefBuilder(props.navbar.subdomain, props.navbar.unlock_reports_url);
        const linkText = props.navbar.report_credits ? 'Unlock Reports' : 'Buy More Report Credits';
        const purchaseText = 'Buy more report credits.';

        return (
            <Modal
            className={{
                base: 'report-credit-modal-content',
                afterOpen: `report-credit-modal-content_after-open hide-on-print`,
                beforeClose: `report-credit-modal-content_before-close hide-on-print`,
            }}
            overlayClassName={{
                base: 'overlay-base hide-on-print',
                afterOpen: 'overlay-base_after-open hide-on-print',
                beforeClose: 'overlay-base_before-close hide-on-print',
            }}
            isOpen={modalOpen}
            onRequestClose={() => setModalOpen(false)}
            shouldCloseOnOverlayClick
            closeTimeoutMS={0}
            contentLabel="Unlocking Report Features with Report Credits"
            ariaHideApp={false}
            >
            <div>
                <h1>Unlock Reports to Access This Feature</h1>
                <div className="unlock-report-container">
                    <p>
                    {`You have ${props.navbar.report_credits} Report Credits left.`}{' '}
                    <a className="btn btn-primary unlock-report-btn" href={unlockReportsURL}>
                        {linkText}
                    </a>
                    </p>
                </div>
                <a className="btn btn-primary manage-subscription-btn" href={manageSubscriptionsURL}>
                    Manage Your Subscription
                </a>
                <p>Click anywhere outside to close this pop-up.</p>
            </div>
            </Modal>
        );
    }

    return (
        <div ref={ref} className="report-views-popover">
            <ReportCreditPlanModal />
            <div className="all-report-and-views-container">
                <div key="default-views" className="all-report-views-container">
                    <div key="pvd-reports-header" className="all-reports-view-header">
                        <img
                            className="peerview-logo-report-option"
                            src={peerviewLogo}
                            alt="Peerview Data Logo"
                        />{' '}
                        <span>Peerview Reports</span>
                    </div>
                    <div key="money-header" className="peerview-report-section-title">
                        Money
                    </div>
                    <div
                        key="pnl"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'pnl', name: 'Profit & Loss', report: 'pnl' })}
                    >
                        Profit & Loss
                    </div>
                    {naicsFocusedReport && (
                        <div
                            key="docs_pnl"
                            className="report-option"
                            onClick={() => handleNewStandardTab({ key: 'docs_pnl', name: "Doctor's P&L", report: 'docs_pnl' })}
                        >
                            Doctor's P&L
                        </div>
                    )}
                    {naicsFocusedReport && (
                        <div
                            key="functional_expenses"
                            className="report-option"
                            onClick={() => handleNewStandardTab({ key: 'functional_expenses', name: 'Functional Expenses', report: 'functional_expenses' })}
                        >
                            Functional Expenses
                        </div>
                    )}
                    <div
                        key="balance-sheet"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'balance-sheet', name: 'Balance Sheet', report: 'balance-sheet' })}
                    >
                        Balance Sheet
                    </div>
                    <div
                        key="cash-flow"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'cash-flow', name: 'Cash Flow', report: 'cash-flow' })}
                    >
                        Cash Flow
                    </div>
                    <div
                        key="kfis"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'kfis', name: "KFI's", report: 'kfis' })}
                    >
                        Key Financial Indicators (KFIs)
                    </div>
                    <div
                        key="revenue_analysis"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'revenue_analysis', name: "Revenue Analysis", report: 'revenue_analysis' })}
                    >
                        Revenue Analysis
                    </div>
                    <div
                        key="opex_analysis"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'opex_analysis', name: "OpEx Analysis", report: 'opex_analysis' })}
                    >
                        OpEx Analysis
                    </div>
                    <div
                        key="pnl_by_class_qbo"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'pnl_by_class_qbo', name: 'P & L by Class', report: 'pnl_by_class_qbo' })}
                    >
                        P&L By Class (QuickBooks Online)
                    </div>
                    <div
                        key="monthly_kpi_table"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'monthly_kpi_table', name: "KPI Results - Monthly Analysis", report: 'monthly_kpi_table' })}
                    >
                        KPI Results - Monthly Analysis
                    </div>
                    <div
                        key="dashboard"
                        className="report-option"
                        onClick={() => activeTabAccess(findReport('dashboard'), true)}
                    >
                        Dashboard
                    </div>
                    <div
                        key="company_notes"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'company_notes', name: "Client Notes", report: 'company_notes' })}
                    >
                        Client Notes
                    </div>
                    <div key="people-header" className="peerview-report-section-title">
                        People
                    </div>
                    <div
                        key="people_financial_detail"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'people_financial_detail', name: 'People Financial Detail', report: 'people_financial_detail' })}
                    >
                        Financial Detail
                    </div>
                    <div
                        key="people_kpi"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'people_kpi', name: 'People KPI', report: 'people_kpi' })}
                    >
                        Key Performance Indicators (KPIs)
                    </div>
                    <div key="customers-header" className="peerview-report-section-title">
                        Customers
                    </div>
                    <div
                        key="customers_financial_detail"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'customers_financial_detail', name: 'Customers Financial Detail', report: 'customers_financial_detail' })}
                    >
                        Financial Detail
                    </div>
                    <div
                        key="customers_kpi"
                        className="report-option"
                        onClick={() => handleNewStandardTab({ key: 'customers_kpi', name: 'Customers KPI', report: 'customers_kpi' })}
                    >
                        Key Performance Indicators (KPIs)
                    </div>
                </div>
                <div key="admin-default-views" className="default-views-container scroll-container">
                    <div key="analysis-reports-header" className="all-reports-view-header">
                        Analysis Reports
                    </div>
                    {renderCustomReportSection('admin', 'visible_to_all', 'Default Reports')}
                    {renderCustomReportSection('admin', 'by_naics', 'Defaults By NAICS')}
                    {renderCustomReportSection('admin', 'by_parent', 'Defaults By Firm')}
                </div>
                <div key="users-custom-views" className="default-views-container scroll-container">
                    <div key="my-custom-reports-header" className="all-reports-view-header">
                        My Custom Reports
                    </div>
                    <div
                        key="report_builder"
                        className="report-option"
                        onClick={() => activeTabAccess(findReport('report_builder'), true)}
                    >
                        Create A Custom Report
                    </div>
                    {tyVSly ? (
                        <div
                            key="ty_v_ly_month"
                            className="report-option"
                            onClick={() => handleNewStandardTab({ key: 'ty_v_ly_month', name: 'TYvLY - Month', report: 'ty_v_ly_month' })}
                        >
                            TYvLY - Month
                        </div>
                    ) : null}
                    {actVSfor ? (
                        <div
                            key="act_v_for_month"
                            className="report-option"
                            onClick={() => handleNewStandardTab({ key: 'act_v_for_month', name: 'ActvFor - Month', report: 'act_v_for_month' })}
                        >
                            ActvFor - Month
                        </div>
                    ) : null}
                    {tyVSly ? (
                        <div
                            key="ty_v_ly_q"
                            className="report-option"
                            onClick={() => handleNewStandardTab({ key: 'ty_v_ly_q', name: 'TYvLY - Quarter', report: 'ty_v_ly_q' })}
                        >
                            TYvLY - Quarter
                        </div>
                    ) : null}
                    {actVSfor ? (
                        <div
                            key="act_v_for_q"
                            className="report-option"
                            onClick={() => handleNewStandardTab({ key: 'act_v_for_q', name: 'ActvFor - Quarter', report: 'act_v_for_q' })}
                        >
                            ActvFor - Quarter
                        </div>
                    ) : null}
                    {renderCustomReportSection('normal', 'by_user', 'My Custom Reports')}
                </div>
                <div key="other-users-custom-views" className="default-views-container scroll-container">
                    <div key="my-custom-reports-header" className="last-all-reports-view-header">
                        Reports Shared With Me
                    </div>
                    {renderCustomReportSection('normal', 'by_others', 'Reports Shared With Me')}
                </div>
            </div>
        </div >
    );
});

export default ReportTabsPopover;
